import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#EF1412" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/pages/Tokyo-Joes-Sushi-Factory/192448831305274">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Tokyo Joe Sushi Japanese Restaurant Facebook"
              />
            </CFLink>
            <CFLink href="https://www.yelp.ca/biz/tokyo-joe-sushi-richmond">
              <CFImage
                w="40px"
                pr="10px"
                src={yelp}
                alt="Tokyo Joe Sushi Japanese Restaurant Yelp"
              />
            </CFLink>
            <CFLink href="https://www.zomato.com/vancouver/tokyo-joes-sushi-factory-central-richmond-richmond">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Tokyo Joe Sushi Japanese Restaurant Zomato"
              />
            </CFLink>
            {/* <CFLink href="https://www.instagram.com/sushiumi_/">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Tokyo Joe Sushi Japanese Restaurant Instagram"
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#EF1412" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/pages/Tokyo-Joes-Sushi-Factory/192448831305274">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Tokyo Joe Sushi Japanese Restaurant Facebook"
                hover
              />
            </CFLink>
            <CFLink href="https://www.yelp.ca/biz/tokyo-joe-sushi-richmond">
              <CFImage
                w="40px"
                pr="10px"
                src={yelp}
                alt="Tokyo Joe Sushi Japanese Restaurant Yelp"
                hover
              />
            </CFLink>
            <CFLink href="https://www.zomato.com/vancouver/tokyo-joes-sushi-factory-central-richmond-richmond">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Tokyo Joe Sushi Japanese Restaurant Zomato"
                hover
              />
            </CFLink>
            {/* <CFLink href="https://www.instagram.com/sushiumi_/">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Tokyo Joe Sushi Japanese Restaurant Instagram"
                hover
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
